import { AccountBalance, Apartment, BedroomParent, Bungalow, Business, CorporateFare, EmojiTransportation, Fence, Gite, HolidayVillage, Home, House, Landscape, LocationCity, MapsHomeWork, NightShelter, Store, Storefront } from "@mui/icons-material";
import WifiIcon from "@mui/icons-material/Wifi";
import WaterIcon from "@mui/icons-material/Water";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import TvIcon from "@mui/icons-material/Tv";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import FridgeIcon from "@mui/icons-material/Kitchen";
import MicrowaveIcon from "@mui/icons-material/Microwave";
import OutdoorGrillIcon from "@mui/icons-material/OutdoorGrill";
import BathroomIcon from "@mui/icons-material/Bathroom";
import SchoolIcon from "@mui/icons-material/School";
import PoolIcon from "@mui/icons-material/Pool";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import ParkingIcon from "@mui/icons-material/LocalParking";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import LandscapeIcon from "@mui/icons-material/Landscape";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import ParkIcon from "@mui/icons-material/Park";
import AttractionsIcon from "@mui/icons-material/Attractions";
import StoreMallDirectoryIcon from "@mui/icons-material/StoreMallDirectory";
import LocalConvenienceStoreIcon from "@mui/icons-material/LocalConvenienceStore";
import FreeBreakfastIcon from "@mui/icons-material/FreeBreakfast";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import CheckroomIcon from "@mui/icons-material/Checkroom";

export const categories = [
  { name: "Casa", icon: <Home sx={{ fontSize: 30 }} /> },
  { name: "Apartamento", icon: <Apartment sx={{ fontSize: 30 }} /> },
  { name: "Habitación", icon: <BedroomParent sx={{ fontSize: 30 }} /> },
  { name: "Lote", icon: <Landscape sx={{ fontSize: 30 }} /> },
  { name: "Condominio", icon: <HolidayVillage sx={{ fontSize: 30 }} /> },
  { name: "Edificio", icon: <Business sx={{ fontSize: 30 }} /> },
  { name: "Torre", icon: <LocationCity sx={{ fontSize: 30 }} /> },
  { name: "Finca", icon: <Gite sx={{ fontSize: 30 }} /> },
  { name: "Local", icon: <Store sx={{ fontSize: 30 }} /> },
  { name: "Terreno", icon: <Fence sx={{ fontSize: 30 }} /> },
  { name: "Casa independiente", icon: <NightShelter sx={{ fontSize: 30 }} /> },
  { name: "Penthouse", icon: <CorporateFare sx={{ fontSize: 30 }} /> },
  { name: "Townhouse", icon: <Apartment sx={{ fontSize: 30 }} /> },
  { name: "Apartamento loft", icon: <MapsHomeWork sx={{ fontSize: 30 }} /> },
  {
    name: "Apartamento estudio",
    icon: <EmojiTransportation sx={{ fontSize: 30 }} />,
  },
  { name: "Casa de lujo", icon: <House sx={{ fontSize: 30 }} /> },
  { name: "Moderna", icon: <AccountBalance sx={{ fontSize: 30 }} /> },
  { name: "Rústica", icon: <Bungalow sx={{ fontSize: 30 }} /> },
  { name: "Propiedad Comercial", icon: <Storefront sx={{ fontSize: 30 }} /> },
  {
    name: "Oficentro",
    icon: <LocalConvenienceStoreIcon sx={{ fontSize: 30 }} />,
  },
  { name: "Mall", icon: <StoreMallDirectoryIcon sx={{ fontSize: 30 }} /> },
];

export const services = [
  { id: "wifi", icon: <WifiIcon />, label: "Wi-Fi" },
  { id: "tv", icon: <TvIcon />, label: "Televisión" },
  { id: "nevera", icon: <FridgeIcon />, label: "Nevera" },
  { id: "microondas", icon: <MicrowaveIcon />, label: "Microondas" },
  { id: "estufa", icon: <OutdoorGrillIcon />, label: "Estufa" },
  {
    id: "calentador de agua",
    icon: <BathroomIcon />,
    label: "Calentador de agua",
  },
  { id: "lavadora", icon: <LocalLaundryServiceIcon />, label: "Lavadora" },
  { id: "secadora", icon: <LocalLaundryServiceIcon />, label: "Secadora" },
  { id: "agua", icon: <WaterIcon />, label: "Agua" },
  { id: "electricidad", icon: <FlashOnIcon />, label: "Electricidad" },
  { id: "limpieza", icon: <CleaningServicesIcon />, label: "Limpieza" },
];

export const amenities = [
  {
    id: "cerca de la escuela",
    icon: <SchoolIcon />,
    label: "Cerca de la Escuela",
  },
  {
    id: "vista a las montañas",
    icon: <LandscapeIcon />,
    label: "Vista a las Montañas",
  },
  { id: "piscina", icon: <PoolIcon />, label: "Piscina" },
  {
    id: "parking de visitas",
    icon: <ParkingIcon />,
    label: "Parking de Visitas",
  },
  {
    id: "seguridad 24 horas",
    icon: <LocalPoliceIcon />,
    label: "Seguridad 24 Horas",
  },
  { id: "jardín o parque", icon: <ParkIcon />, label: "Jardín o Parque" },
  {
    id: "parque infantil",
    icon: <AttractionsIcon />,
    label: "Parque Infantil",
  },
  { id: "gimnasio", icon: <FitnessCenterIcon />, label: "Gimnasio" },
  { id: "estacionamiento", icon: <ParkingIcon />, label: "Estacionamiento" },
  {
    id: "aire acondicionado",
    icon: <AcUnitIcon />,
    label: "Aire Acondicionado",
  },
  { id: "desayunador", icon: <FreeBreakfastIcon />, label: "Desayunador" },
  {
    id: "sala y comedor",
    icon: <TableRestaurantIcon />,
    label: "Sala y Comedor",
  },
  { id: "Walk-in-closet", icon: <CheckroomIcon />, label: "Walk-In-Closet" },
];